function _(t,n,r){var o=Object.prototype.toString,c=o.call(function(){return arguments}());n.exports=function(t){return o.call(t)===c}}
//# sourceMappingURL=is-arguments.min.js.map